// Data layer for tax number validation (RAT-1911).
import requestApi from 'utils/Request';
import { VALIDATE_TAX_NUMBER } from 'utils/StaticApiEndpoints';

// Verdicts the backend can return - kept in sync with TinVerdict in
// revive-backend/src/common/constants/tin-validation.constants.ts.
export const TIN_VERDICT = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  INVALID_SIMILAR: 'INVALID_SIMILAR',
  VALID_REMOVED: 'VALID_REMOVED',
  VALID_REVOKED: 'VALID_REVOKED',
  UNVERIFIED: 'UNVERIFIED',
  FORMAT_INVALID: 'FORMAT_INVALID',
  NO_REGISTRY: 'NO_REGISTRY',
};

/**
 * Ask the registry about one tax number. The backend decides which of taxId /
 * vatNumber is the one AEAT or VIES can actually confirm, so both are sent.
 * Returns null when the request itself fails - the caller then shows nothing
 * rather than inventing a verdict.
 */
export const validateTaxNumber = async ({
  taxId,
  vatNumber,
  legalName,
  countryCode,
  country,
}) => {
  try {
    const { data } = await requestApi.post(VALIDATE_TAX_NUMBER, {
      taxId,
      vatNumber,
      legalName,
      countryCode,
      country,
    });
    return data ?? null;
  } catch {
    return null;
  }
};
